/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { myFunctions } from '@/firebase'
import allLangs from '@/assets/allLangs.json'

const translateText = async ({
  target_text,
  language,
  toLanguage,
  model = 'gpt-4o-mini',
}: {
  target_text: string
  language: string
  toLanguage: string
  model?: string
}) => {
  // Convert language codes to full language names
  // @ts-ignore
  const fromLanguage: string = allLangs[language] || language
  // @ts-ignore
  const toLanguageName: string = allLangs[toLanguage] || toLanguage

  const { data } = await myFunctions.createChatCompletion({
    chat: {
      model: model,
      messages: [
        {
          role: 'user',
          content: [
            {
              type: 'text',
              text: `Translate the following text from ${fromLanguage} to ${toLanguageName}:
              
              """${target_text}"""
              
              Please provide only the direct translation without any additional explanations or notes.`,
            },
          ],
        },
      ],
    },
  })
  const response = data?.response?.content

  return response as string
}

export default translateText
